
  import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch,
    Ref
  } from "vue-property-decorator";
  import { ElForm } from "element-ui/types/form";
  import api from "@/api";
  import {
    PayrollRequisitionCreateOrEditDto,
    AuditFlowDto, IncomeRecordCreateOrEditDto, PaymentCategoryDto, FillVoucherNumberInput
  } from "@/api/appService";

  @Component
  export default class FillVoucherNumber extends Vue {
    @Ref() readonly dataForm!: ElForm;


    show = false;

    id:number = 0;


    defaultData: FillVoucherNumberInput = {
      /** 收入金额 */
      voucherNumber: '',
      /**  */
      id:0
    };
    form: FillVoucherNumberInput = { ...this.defaultData };






    @Watch("show")
    async onShowChange(value: boolean) {
      this.form = {...this.defaultData};
      this.form.id = this.id;
      this.$nextTick(() => {
        this.dataForm.clearValidate();
      });
      api.reimbursement.get({id:this.id}).then(res=>{
        this.form.voucherNumber = res!.voucherNumber;
      })
    }




    async save() {
      console.log(this.form);
      this.dataForm.validate(async (valid: boolean) => {
        if (valid) {
          await api.reimbursement.fillVoucherNumber({body:this.form});
          this.show = false;
          this.$message.success("更新成功");
          this.$emit("onSave");
        }
      });
    }

    cancel() {
      this.show = false;
    }

    roleRule = {
      voucherNumber: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ]
    };
  }
